import React from "react";

export default class DateTime extends React.Component<any, any> {
  render() {
    const { field, form, ...props } = this.props;
    return (
      <input
        id={field.name}
        {...field}
        {...props}
        data-datetimeformat="mm/dd/yy H:M:S"
        type="datetime-local"
      />
    );
  }
}
